var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "712.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 712.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#ffac41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3580 12785 c-237 -33 -2681 -457 -2734 -474 -84 -28 -158 -76 -246 -159 -209 -194 -357 -524 -399 -887 -12 -109 -4 282 -106 -4975 -47 -2384 -88 -4474 -91 -4645 -7 -336 -1 -426 41 -595 55 -221 158 -394 295 -495 54 -39 1060 -515 1140 -539 166 -49 354 12 520 171 166 157 286 374 355 638 52 203 54 228 80 1526 13 672 28 1225 32 1229 4 4 438 80 963 169 525 90 998 175 1050 188 286 74 606 242 880 461 135 107 373 345 498 495 1074 1292 1530 3440 1102 5183 -106 430 -283 867 -480 1182 -220 352 -527 665 -820 837 -103 60 -1153 554 -1279 601 -245 92 -541 125 -801 89z m900 -2870 c267 -541 299 -1297 83 -2005 -14 -47 -50 -146 -80 -220 -219 -547 -574 -943 -964 -1075 -38 -13 -217 -49 -397 -80 -180 -31 -388 -67 -462 -80 -74 -13 -137 -22 -140 -20 -5 3 58 3336 63 3341 1 2 405 72 897 157 l895 154 23 -26 c12 -14 49 -80 82 -146z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);
export default __webpack_public_path__ + "static/media/pe.bd1977c0e85618b510447cee59237b1c.svg";
export { ForwardRef as ReactComponent };